import React from 'react';
import { svgCmps } from './iconMap';

/**
 * <svg />组件，无额外包装，根据type选择图标
 * @param {Object} props
 * @param {string} props.type 详见iconMap.js
 * @param {string} [props.color] 颜色
 * @returns
 */
export default function SvgIcon({ type, color, style, size, className = '', ...others }) {
  const Cmp = svgCmps[type];

  return Cmp ? (
    <Cmp
      className={`${className} t-icon`}
      style={{
        color,
        fill: 'none',
        fontSize: size,
        ...style,
      }}
      {...others}
    />
  ) : null;
}
